import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode, MatDialog } from '@angular/material';
import { GlobalService } from 'src/app/global.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-daily-cash-collection',
  templateUrl: './daily-cash-collection.component.html',
  styleUrls: ['./daily-cash-collection.component.scss']
})
export class DailyCashCollectionComponent implements OnInit {

  selected_date: any;
  is_document_available: boolean = true;
  document_file: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  title: any;
  tomorrow: any = null;
  pdf_data: any;

  constructor(private httpService: HttpService, private dialog: MatDialog, private dom: DomSanitizer,  private global: GlobalService) {
    this.title = this.global._active_display_name;
  }

  getClicked() {
    let data_dict = {
      'selected_date': this.selected_date,
    };
    console.log(data_dict);
    this.is_document_available = false;
    this.httpService.generateFinanceReportOnDeliveryDate(data_dict).subscribe((data) => {
      console.log(data);
      this.pdf_data = this.dom.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + data['pdf']);
      this.document_file = data;
      this.is_document_available = true;
    }, (error) => {
      this.is_document_available = true;
    });
  }

  downloadClicked() {
    const linkSource = 'data:application/pdf;base64,' + this.document_file['pdf'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  changeEvent() {
    let date_in_format = new Date(this.selected_date);
    date_in_format.setDate(date_in_format.getDate() + 1);
    this.tomorrow= new Date(date_in_format).toISOString().split('T')[0];
    this.document_file = null;
  }

  ngOnInit() {
  }

}
